/**
 * Format a Google Distance Matrix ETA for display, optionally adding a
 * company-defined tolerance buffer (in minutes).
 *
 * @param {{seconds: number|null}|null} eta  Result emitted by TrackingMap.
 * @param {number} toleranceMin  Extra minutes to add on top of the raw ETA.
 * @returns {{label: string, totalMinutes: number}|null}
 */
export function formatEta(eta, toleranceMin = 0) {
  if (!eta || typeof eta.seconds !== "number") return null;
  const baseMin = Math.max(0, Math.round(eta.seconds / 60));
  const tol = Math.max(0, parseInt(toleranceMin, 10) || 0);
  const total = baseMin + tol;
  let label;
  if (total < 1) {
    label = "menos de 1 min";
  } else if (total < 60) {
    label = `${total} min`;
  } else {
    const h = Math.floor(total / 60);
    const m = total % 60;
    label = m === 0 ? `${h} h` : `${h} h ${m} min`;
  }
  return { label, totalMinutes: total };
}
